import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    en: {
        kycFormTitle: 'Know Your Customer Form',
        kyeFormTitle: 'Know Your Employee Form',
        kyeFileDefaultDownloadUrl : 'For Turkish Kye form',
        kyeFileDefaultDownloadUrl_en : 'For English Kye form',
        kycFileDefaultDownloadUrl : 'For Turkish Kyc form',
        kycFileDefaultDownloadUrl_en : 'For English Kyc form',
        kysFileDefaultDownloadUrl : 'For Turkish Kys form',
        kysFileDefaultDownloadUrl_en : 'For English Kys form',
        kyeQuestion: 'Is the relevant employee at the managerial level or authorized to sign?',
        kycQuestion: 'Are we working with the customer under a written contract or in an ongoing repetative business relationship OR Is the customer a government institution / a non-governmental organization (NGO) / a foundation / a society / an international organization?',
        kysQuestion1: 'Is the planned purchase amount for the calendar year over 50,000 €?',
        kysQuestion2: 'Is the country where the supplier operates high-risk? (Please refer to the Country Risk Assessment document for high-risk countries.)',
        kysQuestion3: 'Does the purchase involve a high-risk product? (Please refer to the Country Risk Assessment document for high-risk countries.)',
        kysQuestion4: 'Is the supplier a government entity or are the supplier\'s officials classified as civil servants?',
        addNewForm: 'Add New Form',
        kyeFormList: 'KYE Form List',
        kycFormList: 'KYC Form List',
        kysFormList: 'KYS Form List',
        kyeEmployeeName : 'Employee Name Surname',
        identityNumber : 'Identity Number',
        identityOrPassportNumber : 'Identity Or Passport Number',
        date: 'Date',
        click: 'Click Here',
        code: 'Code',
        creator: 'Creator',
        createDate: 'Creation Date',
        vendorName: 'Vendor Name',
        createdBy : 'Created By',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        updater: 'Editor',
        uploadKyeForm: 'Upload KYE Form',
        uploadKycForm: 'Upload KYC Form',
        uploadKysForm: 'Upload KYS Form',
        uploadedKyeForm: 'Uploaded KYE Form',
        uploadedKycForm: 'Uploaded KYC Form',
        uploadedKysForm: 'Uploaded KYS Form',
        uploadedForm: 'Uploaded Form',
        viewUploadedForm: 'View Uploaded Form',
        uploadedBy : 'Uploaded By',
        uploadDate: 'Upload Date',
        close : 'Close',
        save: 'Save',
        delete: 'Delete',
        yes: 'Yes',
        no: 'No',
        saveSuccess: 'Form saved successfully',
        deletePrompt: 'Are you sure you want to delete this entry?',
        taxNumber : 'Tax Number',
        status : 'Status',
        kysStatus1: 'Below the Importance Level',
        kysStatus2: 'Above the Importance Level, Subject to the KYS Process',
        kysStatus3: 'KYS Process Concluded: Workable',
        kysStatus4: 'KYS Process Concluded: Not Workable',
        menuKYETitle: 'KYE FORMS',
        menuKYCTitle: 'KYC FORMS',
        menuKYSTitle: 'KYS FORMS',
        menuMrfOnay: 'MRF ONAY',
        kysWarningMessage : 'If any of the above questions are answered YES, the supplier is considered to be "above the materiality level" and the QMS process must be carried out for the supplier. Otherwise, the supplier must continue with the general information form.',
    },
    tr: {
        kycFormTitle: 'Müşterini Tanı Formu',
        kyeFormTitle: 'Çalışanını Tanı Formu',
        kyeFileDefaultDownloadUrl : 'Türkçe Kye Formu için',
        kyeFileDefaultDownloadUrl_en : 'İngilizce Kye Formu için',
        kycFileDefaultDownloadUrl : 'Türkçe Kyc Formu için',
        kycFileDefaultDownloadUrl_en : 'İngilizce Kyc Formu için',
        kysFileDefaultDownloadUrl : 'Türkçe Kys Formu için',
        kysFileDefaultDownloadUrl_en : 'İngilizce Kys Formu için',
        kyeQuestion: 'İlgili çalışan yönetici seviyesinde mi veya imza yetkilisi mi?',
        kycQuestion: 'Müşteriyle yazılı bir sözleşme kapsamında mı yoksa devam eden tekrarlayan bir iş ilişkisi içinde mi çalışıyoruz YOKSA Müşteri bir kamu kurumu / sivil toplum örgütü (STK) / vakıf / dernek / uluslararası bir kuruluş mu?',
        kysQuestion1: 'Bir takvim yılı içerisinde gerçekleştirilmesi planlanan satın alma tutarı 50.000 € üzerine mi?',
        kysQuestion2: 'Tedarikçinin faaliyet gösteriği ülke yüksek riskli mi? (Lütfen yüksek riskli ülkeler için Ülke Risk Değerlendirme dokümanını dikkate alın)',
        kysQuestion3: 'Satın alma işlemi yüksek riskli bir ürün ihtiva etmekte midir? (Lütfen yüksek riskli ürünler için Ürün Risk Değerlendirme dokümanını dikkate alın)',
        kysQuestion4: 'Tedarikçi bir devlet kurumu veya Tedarikçi yetkilileri devlet memuru statüsünde midir?',
        addNewForm: 'Yeni Form Oluştur',
        kyeFormList: 'KYE Form Listesi',
        kycFormList: 'KYC Form Listesi',
        kysFormList: 'KYS Form Listesi',
        kyeEmployeeName : 'Çalışanın Adı Soyadı',
        identityNumber : 'Kimlik No',
        identityOrPassportNumber : 'Vergi / Kimlik No',
        date: 'Tarih',
        click: 'tıklayınız',
        code: 'Kodu',
        creator: 'Oluşturan',
        createDate: 'Oluşturma Tarihi',
        vendorName: 'Tedariçi Ünvanı',
        dvendorName: 'Tedariçi Ünvanı',
        createdBy : 'Oluşturan',
        modifiedBy: 'Güncelleyen',
        modifiedDate: 'Güncelleme Tarihi',
        updater: 'Değiştiren',
        uploadKyeForm: 'KYE Formunu Yükleyin',
        uploadKycForm: 'KYC Formunu Yükleyin',
        uploadKysForm: 'KYS Formunu Yükleyin',
        uploadedKyeForm: 'Yüklenen KYE Formları',
        uploadedKycForm: 'Yüklenen KYC Formları',
        uploadedKysForm: 'Yüklenen KYS Formları',
        uploadedForm: 'Yüklenen Form',
        viewUploadedForm: 'Görüntüle',
        uploadedBy : 'Yükleyen',
        uploadDate: 'Yükleme Tarihi',
        close : 'Kapat',
        save: 'Kaydet',
        delete: 'Sil',
        yes: 'Evet',
        no: 'Hayır',
        saveSuccess: 'Form kaydedildi',
        deletePrompt: 'Bu kaydı silmek istediğinizden emin misiniz?',
        taxNumber : 'Vergi No',
        status : 'Durum',
        kysStatus1: 'Önemlilik Düzeyinin Altındadır',
        kysStatus2: 'Önemlilik Düzeyinin Üzerindedir, KYS Sürecine Tabidir',
        kysStatus3: 'KYS Süreci Sonuçlanmıştır : Çalışılabilir',
        kysStatus4: 'KYS Süreci Sonuçlanmıştır : Çalışılamaz',
        menuKYETitle: 'KYE FORMU',
        menuKYCTitle: 'KYC FORMU',
        menuKYSTitle: 'KYS FORMU',
        menuMrfOnay: 'MRF ONAY',
        kysWarningMessage : 'Yukarıdaki soruların herhangi birine EVET yanıtı verildiği durumlara tedarikçi "önemlilik düzeyinin üzerinde" olarak değerlendirilir ve tedarikçi için KYS süreci yürütülmelidir. Aksi durumda tedarikçi genel bilgi formu üzerinden devam etmelidir.',
    }
};

const i18n = new VueI18n({
    locale: 'tr', // Varsayılan dil
    messages,
});

export default i18n;